module.exports = __webpack_public_path__ + "img/codey@2x.b9db8d8a.png";